// src/slices/logsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../api/axiosInstance';

const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/api/logs/`;

// Fetch logs from API (server-side pagination + filtering)
export const fetchLogs = createAsyncThunk('logs/fetchLogs', async (params = {}) => {
  const { page = 0, pageSize = 25, note, user, startDate, endDate } = params;

  const query = {
    page: page + 1, // DRF PageNumberPagination is 1-indexed
    page_size: pageSize,
  };
  if (note) query.note = note;
  if (user) query.user = user;
  if (startDate) query.start_date = startDate;
  if (endDate) query.end_date = endDate;

  const response = await axios.get(BASE_URL, { params: query });
  return response.data;
});

const logsSlice = createSlice({
  name: 'logs',
  initialState: {
    list: [],
    count: 0,
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLogs.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchLogs.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.list = action.payload.results;
        state.count = action.payload.count;
      })
      .addCase(fetchLogs.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default logsSlice.reducer;
